import { Component, Input, OnInit, ViewChild, TemplateRef, Optional, HostBinding } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Utils } from 'src/app/editor/utils';
import projectCategoriesSource from './../../admin/projects/projectcategories';

@Component({
  selector: 'app-examples',
  templateUrl: './examples.component.html',
  styleUrls: ['./examples.component.scss'],
  host: {
    '[style.display]': "'flex'",
    '[style.flex-direction]': "'column'",
    '[style.height]': "'100%'",
    '[style.overflow]': "'hidden'" // Prevent app-examples itself from scrolling
  }
})
export class ExamplesComponent implements OnInit {
  //   Example I Tesla
  // Example II Desk
  // Example III Building
  // Example IV Frame with Motors
  // Example V Molecule
  // Example VI Energy Visualization, Solar


  @Input() treenodes: any;
  @Input() idstr: string = 'publicCategoryID';

  // Add ViewChild for the dialog template
  @ViewChild('dialogTemplate') dialogTemplate!: TemplateRef<any>;

  isLoading: boolean = true; // Added for loading animation

  path = "root";
  entries: any;


  nodes: any = null;

  curprojects: any = null;
  selectedProjectForPreview: any = null;



  constructor(
    public afs: AngularFirestore,
    public dialog: MatDialog, // MatDialog service for opening other dialogs
    @Optional() public dialogRef: MatDialogRef<ExamplesComponent> // Reference to this dialog instance
  ) {






  }

  oldpath = "";
  curnode = null;
  changePath(path, index, node) {
    this.curnode = node;
    console.log(path, index);
    this.oldpath = this.path;
    this.path = this.path + "[" + index + "].children";
    console.log(this.path);

    this.entries = Utils.getValue(this.nodes, this.path);
    console.log(this.entries);
    this.curprojects = null;

    this.afs.collection('projectspublic', ref => ref.where(this.idstr, "==", node.id)).valueChanges({ idField: "id" }).subscribe(data => {
      this.curprojects = data;
      console.log("curprojects", this.curprojects);
    });


  }

  upPath(path) {
    console.log("uppath", path);
    if (path == "") return;
    var p = path.split("[");
    this.oldpath = "";
    for (var i = 0; i < p.length - 1; i++) {
      // überler hack
      if (p[i].startsWith("0") || p[i].startsWith("1") || p[i].startsWith("2") || p[i].startsWith("3") || p[i].startsWith("4") || p[i].startsWith("5") || p[i].startsWith("6") || p[i].startsWith("7") || p[i].startsWith("8") || p[i].startsWith("9"))
        p[i] = "[" + p[i];
      this.oldpath += p[i];
    }

    console.log('oladpath', this.oldpath);

    // letzte löschen! = this.path;
    this.path = path;


    // if (this.path.endsWith("]"))
    //   this.path = this.path.substring(0, this.path.length - 3);

    this.entries = Utils.getValue(this.nodes, this.path);

    // remove last .children as string from string
    var npath = this.path.substring(0, this.path.length - 9);
    var n = Utils.getValue(this.nodes, npath);
    this.curnode = n;

    console.log("uppath", this.path, npath, n);

    this.curprojects = null;
    if (n)
      this.afs.collection('projectspublic', ref => ref.where(this.idstr, "==", n.id)).valueChanges({ idField: "id" }).subscribe(data => {
        this.curprojects = data;
        console.log("curprojects", this.curprojects);
      });
  }


  ngOnInit(): void {
    if (!this.treenodes) {
      this.nodes = projectCategoriesSource.nodes;
    } else {
      this.nodes = this.treenodes;
    }

    console.log("nodes from projectCategoriesSource", this.nodes);
    this.entries = Utils.getValue(this.nodes, "root");

    // Simulate a delay for testing the loading spinner
    setTimeout(() => {
      this.isLoading = false; // Stop loading animation after initialization
    }, 2000); // 2-second delay
  }


  selectProjectForPreview(p: any): void {
    console.log("Project selected for preview", p);
    this.selectedProjectForPreview = p;
  }

  confirmSelection(): void {
    console.log("Confirming selection", this.selectedProjectForPreview);
    if (this.selectedProjectForPreview && this.dialogRef) {
      this.dialogRef.close(this.selectedProjectForPreview);
    } else if (this.selectedProjectForPreview) {
      console.warn('ExamplesComponent: dialogRef not available or no project to confirm. Logging selected project.');
    } else {
      console.warn('ExamplesComponent: No project selected to confirm.');
    }
  }

  // Add methods to handle the dialog
  openDialog(): void {
    const dialogRef = this.dialog.open(this.dialogTemplate, {
      width: '300px',
      // You can pass data to the dialog here if needed
      // data: { name: 'some data' } 
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      if (result) {
        console.log('Dialog result:', result);
        // Handle the result here (e.g., save the input)
      }
    });
  }

  onNoClick(): void {
    // If this component is a dialog, this method should close it.
    if (this.dialogRef) {
      this.dialogRef.close(); // Close without a result
    } else {
      console.warn('ExamplesComponent: onNoClick called, but dialogRef not available.');
    }
    // console.log('Cancel clicked. Dialog should be closed by [mat-dialog-close] in template.');
  }
}
